import { BRANDS, KNOWN_BRAND_IDS } from './registry';
import { BrandNotConfiguredError, resolveBrandId } from './resolve';
import type { BrandConfig } from './types';
import { validateBrand } from './validate';

/** The brand with this id, validated. Throws if unknown or invalid. */
export function getBrandById(id: string | undefined): BrandConfig {
  const resolved = resolveBrandId({ BRAND_ID: id }, KNOWN_BRAND_IDS);
  const brand = BRANDS[resolved];
  const { ok, errors } = validateBrand(brand);
  if (!ok) throw new BrandNotConfiguredError(`brand "${resolved}" is invalid: ${errors.join('; ')}`);
  return brand;
}

let cached: BrandConfig | undefined;

/**
 * The brand of this installation (backend, Next.js server and client).
 * Each variable is read by its literal name so bundlers can inline it.
 */
export function getBrand(): BrandConfig {
  if (!cached) {
    const id = resolveBrandId(
      {
        BRAND_ID: process.env.BRAND_ID,
        NEXT_PUBLIC_BRAND_ID: process.env.NEXT_PUBLIC_BRAND_ID,
      },
      KNOWN_BRAND_IDS,
    );
    cached = getBrandById(id);
  }
  return cached;
}

/** Test helper: forget the memoised brand. */
export function resetBrandCache(): void {
  cached = undefined;
}
